export default __webpack_public_path__ + "static/media/verdinhos-e-coloridos.24eca9ff.jpg";